module.exports = __webpack_public_path__ + "static/media/press-placeholder.5e55f642.webp";